var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Available Filters - 01")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0287302,9.91666667 C12.9321676,9.91666667 14.4752084,11.5023248 14.4752084,13.4583333 L14.4752084,13.4583333 L14.4752084,14.875 C14.4752084,15.2662017 14.1666002,15.5833333 13.7859128,15.5833333 C13.4052253,15.5833333 13.0966171,15.2662017 13.0966171,14.875 L13.0966171,14.875 L13.0966171,13.4583333 C13.0966171,12.2847282 12.1707926,11.3333333 11.0287302,11.3333333 L11.0287302,11.3333333 L5.51436511,11.3333333 C4.3723027,11.3333333 3.44647819,12.2847282 3.44647819,13.4583333 L3.44647819,13.4583333 L3.44647819,14.875 C3.44647819,15.2662017 3.13787002,15.5833333 2.75718256,15.5833333 C2.37649509,15.5833333 2.06788692,15.2662017 2.06788692,14.875 L2.06788692,14.875 L2.06788692,13.4583333 C2.06788692,11.5023248 3.61092776,9.91666667 5.51436511,9.91666667 L5.51436511,9.91666667 Z M8.27154767,1.41666667 C10.174985,1.41666667 11.7180259,3.00232484 11.7180259,4.95833333 C11.7180259,6.91434182 10.174985,8.5 8.27154767,8.5 C6.36811032,8.5 4.82506947,6.91434182 4.82506947,4.95833333 C4.82506947,3.00232484 6.36811032,1.41666667 8.27154767,1.41666667 Z M8.27154767,2.83333333 C7.12948526,2.83333333 6.20366075,3.78472824 6.20366075,4.95833333 C6.20366075,6.13193843 7.12948526,7.08333333 8.27154767,7.08333333 C9.41361007,7.08333333 10.3394346,6.13193843 10.3394346,4.95833333 C10.3394346,3.78472824 9.41361007,2.83333333 8.27154767,2.83333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Demo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Settings---01",
    transform: "translate(-287.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(285.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16.5430953,
    height: 17
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user_management.1cb84fb9.svg";
export { ForwardRef as ReactComponent };